module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Forms Select"), _c('small', [_c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Forms ")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Select")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h4', [_vm._v("Basic Usage")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("v-model")]), _vm._v(" is the value of "), _c('code', [_vm._v("el-option")]), _vm._v(" that is currently selected.")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Disable Options")]), _vm._v(" "), _c('p', [_vm._v("Set the value of "), _c('code', [_vm._v("disabled")]), _vm._v(" in "), _c('code', [_vm._v("el-option")]), _vm._v(" to "), _c('code', [_vm._v("true")]), _vm._v(" to disable this option.")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select Disable Option"
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, _vm._l((_vm.options2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value,
        "disabled": item.disabled
      }
    })
  }), 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Grouping")]), _vm._v(" "), _c('p', [_vm._v("Use "), _c('code', [_vm._v("el-option-group")]), _vm._v(" to group the options, and its "), _c('code', [_vm._v("label")]), _vm._v(" attribute stands for the name of the group.")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.value7),
      callback: function($$v) {
        _vm.value7 = $$v
      },
      expression: "value7"
    }
  }, _vm._l((_vm.options3), function(group) {
    return _c('el-option-group', {
      key: group.label,
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.options), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }), 1)
  }), 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Remote Search")]), _vm._v(" "), _c('p', [_vm._v("Enter keywords and search data from server.")]), _vm._v(" "), _c('p', [_vm._v("Set the value of "), _c('code', [_vm._v("filterable")]), _vm._v(" and "), _c('code', [_vm._v("remote")]), _vm._v(" with "), _c('code', [_vm._v("true")]), _vm._v(" to enable remote search, and you should pass the "), _c('code', [_vm._v("remote-method")]), _vm._v(". "), _c('code', [_vm._v("remote-method")]), _vm._v(" is a "), _c('code', [_vm._v("Function")]), _vm._v(" that gets called when the input value changes, and its parameter is the current input value. Note that if "), _c('code', [_vm._v("el-option")]), _vm._v(" is rendered with the "), _c('code', [_vm._v("v-for")]), _vm._v(" directive, you should add the "), _c('code', [_vm._v("key")]), _vm._v(" attribute for "), _c('code', [_vm._v("el-option")]), _vm._v(". Its value needs to be unique, such as "), _c('code', [_vm._v("item.value")]), _vm._v(" in the following example.")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "remote": "",
      "placeholder": "Please enter a keyword",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading
    },
    model: {
      value: (_vm.value9),
      callback: function($$v) {
        _vm.value9 = $$v
      },
      expression: "value9"
    }
  }, _vm._l((_vm.options4), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73fa80c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/form/FormSelect.vue
// module id = 1407
// module chunks = 2